import { z } from "zod";
import { TimestampSchema } from "./common.js";
import { EntitySchema } from "./entity.js";
import { ToolCallSchema } from "./tool.js";
export const TokenUsageSchema = z.object({
    inputTokens: z.number().int().nonnegative(),
    outputTokens: z.number().int().nonnegative(),
    cacheReadTokens: z.number().int().nonnegative(),
    cacheCreationTokens: z.number().int().nonnegative(),
    usd: z.number().nonnegative(),
});
/** Token-budgeted context assembled for every run (DESIGN §9). */
export const ContextBundleSchema = z.object({
    tokenBudget: z.number().int().positive(),
    profile: z.array(z.object({
        key: z.string(),
        value: z.string(),
        source: z.string(),
        confidence: z.number().min(0).max(1),
        observedAt: TimestampSchema,
    })),
    memories: z.array(z.object({ id: z.string(), text: z.string(), source: z.string() })),
    focus: EntitySchema.nullable(),
    recentTasks: z.array(z.object({ taskId: z.string(), summary: z.string() })),
});
export const AgentEventSchema = z.discriminatedUnion("t", [
    z.object({ t: z.literal("text"), delta: z.string() }),
    z.object({ t: z.literal("tool_call"), call: ToolCallSchema }),
    z.object({ t: z.literal("tool_result"), callId: z.string(), result: z.unknown() }),
    z.object({
        t: z.literal("rate_limit"),
        status: z.enum(["allowed", "warning", "rejected"]),
        resetsAt: TimestampSchema.optional(),
    }),
    z.object({
        t: z.literal("cost"),
        usd: z.number().nonnegative(),
        /** True for subscription runs: recorded, not charged. */
        notional: z.boolean(),
        byModel: z.record(z.string(), TokenUsageSchema),
        /** True when `usd` is cumulative for a resumed session (ledger stores the delta). */
        cumulative: z.boolean().optional(),
        sessionId: z.string().optional(),
    }),
    z.object({
        t: z.literal("error"),
        kind: z.enum(["rate_limited", "quota", "auth", "budget", "other"]),
        message: z.string().optional(),
        retryAt: TimestampSchema.optional(),
    }),
    z.object({ t: z.literal("done"), sessionId: z.string().optional() }),
]);
//# sourceMappingURL=engine.js.map